import { dispatchCustomEvent } from 'utils/hooks/use-custom-event';

function vivochaContainer(payload: { show: boolean }) {
  dispatchCustomEvent<{ show: boolean }>('vivocha-container', payload);
}

export { vivochaContainer };
